import moment from 'moment';

const mapPeCompanyShortFromApi = (
  resp: ApiPeCompanyShortData
): PeCompanyShort => {
  return {
    id: resp.id,
    name: resp.name,
    logoSrc: resp.logo?.url ?? null,
    currency: resp.currency,
    price: resp.share_price,
    lastRoundDate: resp.last_round_date
      ? moment(resp.last_round_date).toDate()
      : null,
    lastRoundSharePrice: resp.last_round_share_price,
    lastRoundVolume: resp.last_round_share_price_total,
    color: resp.color,
    gradientColor: resp.gradient_color,
    tags: resp.tags,
  };
};

export default mapPeCompanyShortFromApi;
